<template>
  <div class="bg-blue-100">
    <div class="p-4 flex gap-2 flex-wrap">
      <img class="mx-auto md:mx-0" src="@/assets/header-logo-white.svg"/>
      <div class="flex flex-wrap gap-4 md:ml-auto">
        <div class="w-full md:w-32">
          <p class="text-white text-md font-bold text-left">Select Jurisdiction:</p>
          <div class="flex border border-gray rounded overflow-hidden items-center bg-white">
            <img v-if="currentCountry" :src="currentCountry.flag" :alt="`${currentCountry.name} flag`"
            class="w-4 h-4 mx-2">
            <div class="self-stretch border-r border-gray"></div>
            <select v-model="selectedCountryName"
            class="flex-1 text-md sm:text-base h-6"
            @input="countryChanged($event)">
              <option v-for="country in countries" :key="country.code" :value="country.name"
                class="block">
                  <div class="flex gap-2">
                    <p>{{country.name}}</p>
                  </div>
              </option>
            </select>
          </div>
        </div>
        <div class="w-full md:w-32">
          <p class="text-white text-md font-bold text-left">Select Language:</p>
          <div class="flex border border-gray rounded overflow-hidden items-center bg-white">
            <select v-model="selectedLanguage"
            class="flex-1 text-md sm:text-base h-6">
              <option v-for="language in languages" :key="language.ID" :value="language.code"
                class="block">
                <p>{{language.displayName}}</p>
              </option>
            </select>
          </div>
        </div>
        <div class="w-full md:w-32">
          <p class="text-white text-md font-bold text-left">T&C Type:</p>
          <div class="flex border border-gray rounded overflow-hidden items-center bg-white">
            <select v-model="selectedTnc"
            class="flex-1 text-md sm:text-base h-6">
              <option v-for="type in tncTypes" :key="type.key" :value="type.key"
                class="block">
                <p>{{type.title}}</p>
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <BodyBox class="content-box">
      <div v-if="tnc.loading" class="flex flex-col gap-2 py-16">
        <p class="text-mid-gray text-xl text-center">Loading...</p>
        <font-awesome-icon icon="spinner" class="animate-spin text-xl text-orange-100"/>
      </div>
      <div v-else v-html="tnc.data" class="content"></div>
    </BodyBox>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import PageTitle from '@/components/PageTitle'
import BodyBox from '@/components/BodyBox'
import ExpandableRow from '@/components/ExpandableRow'

export default {
  name: "terms-n-conditions",
  components:{
    PageTitle,
    BodyBox,
    ExpandableRow
  },
  computed:{
    ...mapGetters({
      countries: "countries",
      currentCountry: "currentCountry",
    }),
    languages(){
      if(!this.currentCountry){
        return([])
      }
      return [{ ID: 2, code: "en", name: "English", displayName: "English" },]
      // return this.currentCountry.languages //TODO: use this once we have all the languages for tnc
    },
    queryTncType(){
      if(this.$route.query.type){
        return this.$route.query.type
      }
      return "troopers_app_tnc"
    }
  },  
  data() {
    return {
      pagePath: "/terms-n-conditions",
      selectedIndex: 0,
      tnc: {
        loading: false,
        data: null
      },
      selectedCountryName: null,
      selectedLanguage: null,
      tncTypes: [
        {
          title: "Troopers App",
          key: "troopers_app_tnc",
        },
        {
          title: "Troopers Protect",
          key: "troopers_protect_tnc",
        },
        {
          title: "Troopers Chat",
          key: "troopers_chat_tnc",
        },
        {
          title: "Business & Enterprise Packages",
          key: "business_series_tnc",
        },
        {
          title: "Flex Packages",
          key: "flex_series_tnc",
        },
      ],
      selectedTnc: this.queryTncType,
    }
  },
  methods:{
    ...mapActions({
      getSysConfig: 'getSysConfig',
      getCountries: "getCountries",
    }),
    getDataFromConfig(){
      this.tnc = {
        loading: true,
        data: null
      }
      this.getSysConfig(`${this.queryTncType}_${this.selectedLanguage}`)
      .then(res=>{
          this.tnc.data = res.data.value
      })
      .catch(err => {
        console.log(err)
      })
      .finally(() => {
        this.tnc.loading = false
      })
    },
    countryChanged(e){
      const newCountryName = e.target.value
      const newCountry = this.countries.find(x=> x.name.toUpperCase() == newCountryName.toUpperCase())
      if(newCountry.name != this.currentCountry.name){
        document.location.href = `${newCountry.webDomain}${this.pagePath}`
      }
    }
  },
  mounted() {
    this.selectedTnc = this.queryTncType
    this.getCountries()
    .then(() => {
      let selectedLanguage = this.languages[0]
      if(this.$route.query.lang){
        selectedLanguage = this.languages.find(x => x.code == this.$route.query.lang.toLowerCase()) || selectedLanguage
      }
      this.selectedLanguage = selectedLanguage.code
    })
  },
  watch: {
    currentCountry(newVal){
      if(newVal){
        this.selectedCountryName = newVal.name
      }
    },
    selectedLanguage(newLanguageCode){
      const newLanguage = this.languages.find(x => x.code == newLanguageCode)
      if(newLanguage && this.$route.query?.lang != newLanguageCode){
        this.$router.push({path: this.pagePath, query: {lang: newLanguageCode}})
      }
      this.$nextTick(() => {
        this.getDataFromConfig()
      })
    },
    selectedTnc(val){
      if(val != this.$route.query.type){
        this.$router.push({path: this.pagePath, query: {...this.$route.query, type: val}})
        this.$nextTick(() => {
          this.getDataFromConfig()
        })
      }
    },
  }
}
</script>

<style scoped>

.content-box{
  width: 100%;
  border-radius: .5em;
  position: relative;
  z-index: 1;
  font-size: .5em;
  text-align: left;
}

.content >>> ol{
  margin-left: 4em !important;
  list-style-type: decimal !important;
}

/*!
 * Quill Editor v2.0.0-dev.3
 * https://quilljs.com/
 * Copyright (c) 2014, Jason Chen
 * Copyright (c) 2013, salesforce.com
 * Modified by Ezra Yong (c) 2025
 */
 
 .ql-container {
  box-sizing: border-box;
  font-family: Helvetica, Arial, sans-serif;
  font-size: 13px;
  height: 100%;
  margin: 0px;
  position: relative;
}
.ql-container.ql-disabled .ql-tooltip {
  visibility: hidden;
}
.ql-container:not(.ql-disabled) li[data-list="checked"] > .ql-ui,
.ql-container:not(.ql-disabled) li[data-list="unchecked"] > .ql-ui {
  cursor: pointer;
}
.ql-clipboard {
  left: -100000px;
  height: 1px;
  overflow-y: hidden;
  position: absolute;
  top: 50%;
}
.ql-clipboard p {
  margin: 0;
  padding: 0;
}
div.content-box > div.content {
  box-sizing: border-box;
  counter-reset: list-0;
  line-height: 1.42;
  height: 100%;
  outline: none;
  overflow-y: auto;
  padding: 12px 15px;
  tab-size: 4;
  -moz-tab-size: 4;
  text-align: left;
  white-space: pre-wrap;
  word-wrap: break-word;
}
div.content-box > div.content > * {
  cursor: text;
}
div.content-box > div.content p,
div.content-box > div.content ol,
div.content-box > div.content pre,
div.content-box > div.content blockquote,
div.content-box > div.content h1,
div.content-box > div.content h2,
div.content-box > div.content h3,
div.content-box > div.content h4,
div.content-box > div.content h5,
div.content-box > div.content h6 {
  margin: 0;
  padding: 0;
}
div.content-box > div.content p,
div.content-box > div.content h1,
div.content-box > div.content h2,
div.content-box > div.content h3,
div.content-box > div.content h4,
div.content-box > div.content h5,
div.content-box > div.content h6 {
  counter-reset: list-0 list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}
div.content-box > div.content table {
  border-collapse: collapse;
}
div.content-box > div.content td {
  border: 1px solid #000;
  padding: 2px 5px;
}
div.content-box > div.content ol {
  padding-left: 1.5em;
}
div.content-box > div.content li {
  list-style-type: decimal;
  padding-left: 1.5em;
  position: relative;
}
div.content-box > div.content li > .ql-ui:before {
  display: inline-block;
  margin-left: -1.5em;
  margin-right: 0.3em;
  text-align: right;
  white-space: nowrap;
  width: 1.2em;
}
div.content-box > div.content li[data-list="checked"] > .ql-ui,
div.content-box > div.content li[data-list="unchecked"] > .ql-ui {
  color: #777;
}
div.content-box > div.content li[data-list="bullet"] > .ql-ui:before {
  content: "\2022";
}
div.content-box > div.content li[data-list="checked"] > .ql-ui:before {
  content: "\2611";
}
div.content-box > div.content li[data-list="unchecked"] > .ql-ui:before {
  content: "\2610";
}
div.content-box > div.content li[data-list="ordered"] {
  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
  counter-increment: list-0;
}
div.content-box > div.content li[data-list="ordered"] > .ql-ui:before {
  content: counter(list-0, decimal) ". ";
}
div.content-box > div.content li[data-list="ordered"].ql-indent-1 {
  counter-increment: list-1;
}
div.content-box > div.content li[data-list="ordered"].ql-indent-1 > .ql-ui:before {
  content: counter(list-1, lower-alpha) ". ";
}
div.content-box > div.content li[data-list="ordered"].ql-indent-1 {
  counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}
div.content-box > div.content li[data-list="ordered"].ql-indent-2 {
  counter-increment: list-2;
}
div.content-box > div.content li[data-list="ordered"].ql-indent-2 > .ql-ui:before {
  content: counter(list-2, lower-roman) ". ";
}
div.content-box > div.content li[data-list="ordered"].ql-indent-2 {
  counter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}
div.content-box > div.content li[data-list="ordered"].ql-indent-3 {
  counter-increment: list-3;
}
div.content-box > div.content li[data-list="ordered"].ql-indent-3 > .ql-ui:before {
  content: counter(list-3, decimal) ". ";
}
div.content-box > div.content li[data-list="ordered"].ql-indent-3 {
  counter-reset: list-4 list-5 list-6 list-7 list-8 list-9;
}
div.content-box > div.content li[data-list="ordered"].ql-indent-4 {
  counter-increment: list-4;
}
div.content-box > div.content li[data-list="ordered"].ql-indent-4 > .ql-ui:before {
  content: counter(list-4, lower-alpha) ". ";
}
div.content-box > div.content li[data-list="ordered"].ql-indent-4 {
  counter-reset: list-5 list-6 list-7 list-8 list-9;
}
div.content-box > div.content li[data-list="ordered"].ql-indent-5 {
  counter-increment: list-5;
}
div.content-box > div.content li[data-list="ordered"].ql-indent-5 > .ql-ui:before {
  content: counter(list-5, lower-roman) ". ";
}
div.content-box > div.content li[data-list="ordered"].ql-indent-5 {
  counter-reset: list-6 list-7 list-8 list-9;
}
div.content-box > div.content li[data-list="ordered"].ql-indent-6 {
  counter-increment: list-6;
}
div.content-box > div.content li[data-list="ordered"].ql-indent-6 > .ql-ui:before {
  content: counter(list-6, decimal) ". ";
}
div.content-box > div.content li[data-list="ordered"].ql-indent-6 {
  counter-reset: list-7 list-8 list-9;
}
div.content-box > div.content li[data-list="ordered"].ql-indent-7 {
  counter-increment: list-7;
}
div.content-box > div.content li[data-list="ordered"].ql-indent-7 > .ql-ui:before {
  content: counter(list-7, lower-alpha) ". ";
}
div.content-box > div.content li[data-list="ordered"].ql-indent-7 {
  counter-reset: list-8 list-9;
}
div.content-box > div.content li[data-list="ordered"].ql-indent-8 {
  counter-increment: list-8;
}
div.content-box > div.content li[data-list="ordered"].ql-indent-8 > .ql-ui:before {
  content: counter(list-8, lower-roman) ". ";
}
div.content-box > div.content li[data-list="ordered"].ql-indent-8 {
  counter-reset: list-9;
}
div.content-box > div.content li[data-list="ordered"].ql-indent-9 {
  counter-increment: list-9;
}
div.content-box > div.content li[data-list="ordered"].ql-indent-9 > .ql-ui:before {
  content: counter(list-9, decimal) ". ";
}
div.content-box > div.content .ql-indent-1:not(.ql-direction-rtl) {
  padding-left: 3em;
}
div.content-box > div.content li.ql-indent-1:not(.ql-direction-rtl) {
  padding-left: 4.5em;
}
div.content-box > div.content .ql-indent-1.ql-direction-rtl.ql-align-right {
  padding-right: 3em;
}
div.content-box > div.content li.ql-indent-1.ql-direction-rtl.ql-align-right {
  padding-right: 4.5em;
}
div.content-box > div.content .ql-indent-2:not(.ql-direction-rtl) {
  padding-left: 6em;
}
div.content-box > div.content li.ql-indent-2:not(.ql-direction-rtl) {
  padding-left: 7.5em;
}
div.content-box > div.content .ql-indent-2.ql-direction-rtl.ql-align-right {
  padding-right: 6em;
}
div.content-box > div.content li.ql-indent-2.ql-direction-rtl.ql-align-right {
  padding-right: 7.5em;
}
div.content-box > div.content .ql-indent-3:not(.ql-direction-rtl) {
  padding-left: 9em;
}
div.content-box > div.content li.ql-indent-3:not(.ql-direction-rtl) {
  padding-left: 10.5em;
}
div.content-box > div.content .ql-indent-3.ql-direction-rtl.ql-align-right {
  padding-right: 9em;
}
div.content-box > div.content li.ql-indent-3.ql-direction-rtl.ql-align-right {
  padding-right: 10.5em;
}
div.content-box > div.content .ql-indent-4:not(.ql-direction-rtl) {
  padding-left: 12em;
}
div.content-box > div.content li.ql-indent-4:not(.ql-direction-rtl) {
  padding-left: 13.5em;
}
div.content-box > div.content .ql-indent-4.ql-direction-rtl.ql-align-right {
  padding-right: 12em;
}
div.content-box > div.content li.ql-indent-4.ql-direction-rtl.ql-align-right {
  padding-right: 13.5em;
}
div.content-box > div.content .ql-indent-5:not(.ql-direction-rtl) {
  padding-left: 15em;
}
div.content-box > div.content li.ql-indent-5:not(.ql-direction-rtl) {
  padding-left: 16.5em;
}
div.content-box > div.content .ql-indent-5.ql-direction-rtl.ql-align-right {
  padding-right: 15em;
}
div.content-box > div.content li.ql-indent-5.ql-direction-rtl.ql-align-right {
  padding-right: 16.5em;
}
div.content-box > div.content .ql-indent-6:not(.ql-direction-rtl) {
  padding-left: 18em;
}
div.content-box > div.content li.ql-indent-6:not(.ql-direction-rtl) {
  padding-left: 19.5em;
}
div.content-box > div.content .ql-indent-6.ql-direction-rtl.ql-align-right {
  padding-right: 18em;
}
div.content-box > div.content li.ql-indent-6.ql-direction-rtl.ql-align-right {
  padding-right: 19.5em;
}
div.content-box > div.content .ql-indent-7:not(.ql-direction-rtl) {
  padding-left: 21em;
}
div.content-box > div.content li.ql-indent-7:not(.ql-direction-rtl) {
  padding-left: 22.5em;
}
div.content-box > div.content .ql-indent-7.ql-direction-rtl.ql-align-right {
  padding-right: 21em;
}
div.content-box > div.content li.ql-indent-7.ql-direction-rtl.ql-align-right {
  padding-right: 22.5em;
}
div.content-box > div.content .ql-indent-8:not(.ql-direction-rtl) {
  padding-left: 24em;
}
div.content-box > div.content li.ql-indent-8:not(.ql-direction-rtl) {
  padding-left: 25.5em;
}
div.content-box > div.content .ql-indent-8.ql-direction-rtl.ql-align-right {
  padding-right: 24em;
}
div.content-box > div.content li.ql-indent-8.ql-direction-rtl.ql-align-right {
  padding-right: 25.5em;
}
div.content-box > div.content .ql-indent-9:not(.ql-direction-rtl) {
  padding-left: 27em;
}
div.content-box > div.content li.ql-indent-9:not(.ql-direction-rtl) {
  padding-left: 28.5em;
}
div.content-box > div.content .ql-indent-9.ql-direction-rtl.ql-align-right {
  padding-right: 27em;
}
div.content-box > div.content li.ql-indent-9.ql-direction-rtl.ql-align-right {
  padding-right: 28.5em;
}
div.content-box > div.content li.ql-direction-rtl {
  padding-right: 1.5em;
}
div.content-box > div.content li.ql-direction-rtl > .ql-ui:before {
  margin-left: 0.3em;
  margin-right: -1.5em;
  text-align: left;
}
div.content-box > div.content table {
  table-layout: fixed;
  width: 100%;
}
div.content-box > div.content table td {
  outline: none;
}
div.content-box > div.content .ql-code-block-container {
  font-family: monospace;
}
div.content-box > div.content .ql-video {
  display: block;
  max-width: 100%;
}
div.content-box > div.content .ql-video.ql-align-center {
  margin: 0 auto;
}
div.content-box > div.content .ql-video.ql-align-right {
  margin: 0 0 0 auto;
}
div.content-box > div.content .ql-bg-black {
  background-color: #000;
}
div.content-box > div.content .ql-bg-red {
  background-color: #e60000;
}
div.content-box > div.content .ql-bg-orange {
  background-color: #f90;
}
div.content-box > div.content .ql-bg-yellow {
  background-color: #ff0;
}
div.content-box > div.content .ql-bg-green {
  background-color: #008a00;
}
div.content-box > div.content .ql-bg-blue {
  background-color: #06c;
}
div.content-box > div.content .ql-bg-purple {
  background-color: #93f;
}
div.content-box > div.content .ql-color-white {
  color: #fff;
}
div.content-box > div.content .ql-color-red {
  color: #e60000;
}
div.content-box > div.content .ql-color-orange {
  color: #f90;
}
div.content-box > div.content .ql-color-yellow {
  color: #ff0;
}
div.content-box > div.content .ql-color-green {
  color: #008a00;
}
div.content-box > div.content .ql-color-blue {
  color: #06c;
}
div.content-box > div.content .ql-color-purple {
  color: #93f;
}
div.content-box > div.content .ql-font-serif {
  font-family:
    Georgia,
    Times New Roman,
    serif;
}
div.content-box > div.content .ql-font-monospace {
  font-family:
    Monaco,
    Courier New,
    monospace;
}
div.content-box > div.content .ql-size-small {
  font-size: 0.75em;
}
div.content-box > div.content .ql-size-large {
  font-size: 1.5em;
}
div.content-box > div.content .ql-size-huge {
  font-size: 2.5em;
}
div.content-box > div.content .ql-direction-rtl {
  direction: rtl;
  text-align: inherit;
}
div.content-box > div.content .ql-align-center {
  text-align: center;
}
div.content-box > div.content .ql-align-justify {
  text-align: justify;
}
div.content-box > div.content .ql-align-right {
  text-align: right;
}
div.content-box > div.content .ql-ui {
  position: absolute;
}
div.content-box > div.content.ql-blank::before {
  color: rgba(0, 0, 0, 0.6);
  content: attr(data-placeholder);
  font-style: italic;
  left: 15px;
  pointer-events: none;
  position: absolute;
  right: 15px;
}
</style>